import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { updateIsNewOnlyAction } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
import type { SearchResultsRoutingParams } from "app/pages/sales-intelligence/modules/leads-search";

export const useIsNewOnlyFilter = () => {
    const dispatch = useDispatch();
    const { params } = useCurrentStateAndParams<SearchResultsRoutingParams>();
    useMount(() => {
        if (params.isNewOnly) {
            dispatch(updateIsNewOnlyAction(Boolean(params.isNewOnly)));
        }
    });
};
